import LegalDoc from "@/components/LegalDoc";
import { COOKIES } from "@/data/cookies";

export default function Cookies() {
  return <LegalDoc doc={COOKIES} testId="cookies-page" />;
}
